import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, authFeatureKey } from '../reducer/auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => state.isAuthenticated,
);
export const selectIsLoading = createSelector(selectAuthState, (state) => state.isLoading);
export const selectAuthToken = createSelector(selectAuthState, (state) => state.token);
